import { render, staticRenderFns } from "./DepartamentoPage.vue?vue&type=template&id=46bf8ce2&"
import script from "./DepartamentoPage.js?vue&type=script&lang=js&"
export * from "./DepartamentoPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports